import type { SongsStore } from './types';

const initialState: SongsStore = {
  page: 0,
  songs: {},
  newSongsInLibrary: false,
  songListPosition: 0,
  ids: [],
  pendingForLibrary: null,
};

export default initialState;
